<div class="card">
  <div class="card-header">
    <h2 class="card-title">Gerenciamento de Pacotes de Produtos</h2>
    <button mat-fab extended color="primary" (click)="openPackageDialog()">
      <mat-icon>add</mat-icon>
      Novo Pacote
    </button>
  </div>

  <div class="card-body">
    <!-- SEÇÃO DE FILTROS -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>filter_list</mat-icon>
          Filtros de Busca
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="filters-content">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Nome do Pacote</mat-label>
          <input matInput [(ngModel)]="filterName" placeholder="Digite o nome do pacote">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        <mat-checkbox [(ngModel)]="showOnlyActive">
          Mostrar apenas ativos
        </mat-checkbox>

        <div class="filter-actions">
          <button mat-raised-button color="primary" (click)="applyFilters()" class="btn btn-primary">
            <mat-icon>search</mat-icon>
            Aplicar Filtros
          </button>
          <button mat-stroked-button (click)="clearFilters()" class="btn btn-ghost">
            <mat-icon>clear</mat-icon>
            Limpar
          </button>
        </div>
      </div>
    </mat-expansion-panel>

    <!-- TABELA DE PACOTES -->
    <div class="table-container">
      <h3 class="title-section">Lista de Pacotes</h3>
      
      <table mat-table [dataSource]="productPackages" class="plans-table">

        <!-- Coluna ID -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let pkg">{{ pkg.id }}</td>
        </ng-container>

        <!-- Coluna Nome -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nome</th>
          <td mat-cell *matCellDef="let pkg">{{ pkg.name }}</td>
        </ng-container>

        <!-- Coluna Tipo -->
        <ng-container matColumnDef="packageType">
          <th mat-header-cell *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let pkg">{{ pkg.packageType}}</td>
        </ng-container>

        <!-- Coluna Status -->
        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let pkg">
            <span class="badge" [ngClass]="pkg.active ? 'badge-success' : 'badge-error'">
              {{ pkg.active ? 'Ativo' : 'Inativo' }}
            </span>
          </td>
        </ng-container>

        <!-- Coluna Itens -->
        <ng-container matColumnDef="items">
          <th mat-header-cell *matHeaderCellDef>Itens</th>
          <td mat-cell *matCellDef="let pkg">{{ getItemsCount(pkg) }}</td>
        </ng-container>

        <!-- Coluna Descontos -->
        <ng-container matColumnDef="discounts">
          <th mat-header-cell *matHeaderCellDef>Descontos</th>
          <td mat-cell *matCellDef="let pkg">{{ getDiscountsCount(pkg) }}</td>
        </ng-container>

        <!-- Coluna Data de Criação -->
        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>Criado em</th>
          <td mat-cell *matCellDef="let pkg">{{ formatDate(pkg.createdAt) }}</td>
        </ng-container>

        <!-- Coluna Ações -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Ações</th>
          <td mat-cell *matCellDef="let pkg">
            <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="loadPackageById(pkg.id!)">
                <mat-icon>visibility</mat-icon>
                <span>Ver Detalhes</span>
              </button>
              <button mat-menu-item (click)="editPackage(pkg)">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="togglePackageStatus(pkg)">
                <mat-icon>{{ pkg.active ? 'block' : 'check_circle' }}</mat-icon>
                <span>{{ pkg.active ? 'Desativar' : 'Ativar' }}</span>
              </button>
              <button mat-menu-item (click)="deletePackage(pkg.id!)">
                <mat-icon>delete</mat-icon>
                <span>Excluir</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            Nenhum pacote encontrado
          </td>
        </tr>
      </table>

      <div class="table-footer">
        <small>Total de pacotes: {{ productPackages.length }}</small>
      </div>
    </div>
  </div>
</div>